import React from "react";

interface ErrorMessageProps{
    error: string
}

export function ErrorMessage(props:ErrorMessageProps){
    return (<p className="text-danger">{props.error}</p>)
}